import InitComponent from "Modules/InitComponent";
import store from "Stores/store";
import MobileMenu from "./components/MobileMenu.vue";

const button = document.getElementById("mobile-menu-toggle");

if (button) {
  button.addEventListener("click", () => {
    store.dispatch("mobileMenu/toggle");
  });

  // The toggle lives in the PHP header, outside the Vue app, so it mirrors the
  // menu state from the store instead of being driven by a template binding.
  store.watch(
    (state) => state.mobileMenu.isMenuActive,
    (isMenuActive) => {
      button.classList.toggle("is-active", isMenuActive);
      button.setAttribute("aria-expanded", String(isMenuActive));
    }
  );
}

const mobileMenuContainer = document.getElementById("mobile-menu-container");

const initComponent = new InitComponent({
  components: { MobileMenu },
  selectors: mobileMenuContainer,
  store,
  template: "<MobileMenu />",
});

initComponent.init();
